var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.65 111.152 59.065-34.45 11.428 7.67a.541.541 0 0 1-.022.914L38.444 119.49a1.624 1.624 0 0 1-1.685-.005L24.64 112.08a.541.541 0 0 1 .01-.93z",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#0E1D31",
    strokeWidth: 1.082
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.57 50.68c7.11-4.031 14.253-5.018 19.731-1.869l1.881 1.085.716.42.726.43.49.294.749.457.508.315.516.325.794.509.541.354.553.367.565.38.578.397.894.625.614.438.63.457.646.476.457.341c.092 6.044-4.52 14.34-9.822 21.75l-.545.757-.829 1.124-.554.737-.556.728-.837 1.077-.836 1.052-.833 1.027-.55.668-.82.977-.539.633-.532.617-.785.896-.766.857-.497.548-.726.787-.47.5c-7.03 7.433-15.613 15.174-25.747 23.22l-1.332 1.053-.395.31-1.527-.817-1.914-1.038L33.03 113l-.784-.437-.733-.414-.847-.484-.621-.361-.707-.419-.509-.308c-4.384-11.209-2.05-25.53 5.788-39.047 5.488-9.464 12.708-16.743 19.952-20.85z",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.36 56.529c7.11-4.03 14.255-5.017 19.733-1.868 3.973 2.284 6.493 6.419 7.596 11.628 1.148 5.42.762 12-1.145 18.93l-52.286 30.455c-4.06-9.356-1.981-24.274 6.15-38.295 5.489-9.465 12.708-16.743 19.953-20.85z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0E1D31",
    strokeWidth: 1.082
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.624 3.38C61.02.321 66.447-.443 70.61 1.951l.52.296.52.289 1.784.98.496.276.492.281c2.083 1.208 3.96 2.52 5.182 4.539.968 1.596 1.518 3.632 1.46 6.39-.108 5.067-2.248 12.493-7.615 23.954-5.089 10.867-9.684 16.555-13.907 19.121-2.4 1.459-4.667 1.886-6.816 1.687-2.87-.266-5.526-1.63-8.01-3.113l-.554-.334-.549-.337-1.622-1.006-.534-.326-.526-.317a43.989 43.989 0 0 0-.526-.307c-4.16-2.392-6.209-7.45-6.246-13.632-.038-6.336 2.041-13.866 6.231-21.092 4.19-7.226 9.701-12.784 15.233-15.92z",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.122 7.86c5.397-3.06 10.823-3.824 14.985-1.431 4.161 2.392 6.209 7.45 6.246 13.632.038 6.336-2.041 13.866-6.231 21.091-4.19 7.226-9.701 12.784-15.232 15.92-5.397 3.06-10.823 3.823-14.985 1.43-4.162-2.391-6.21-7.45-6.247-13.631-.038-6.337 2.042-13.867 6.232-21.092 4.19-7.226 9.7-12.784 15.232-15.92z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.25 48.649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.443 1.473c3.826-1.623 7.854-1.67 11.175.268 3.322 1.938 5.297 5.489 5.82 9.65.527 4.2-.422 9.024-2.967 13.478-2.544 4.453-6.202 7.696-10.065 9.334-3.826 1.622-7.854 1.669-11.175-.268-3.322-1.939-5.297-5.489-5.82-9.65-.527-4.2.422-9.025 2.967-13.478C5.922 6.354 9.58 3.11 13.443 1.473z",
    stroke: "#0E1D31",
    strokeWidth: 0.541,
    fill: "#0E1D31"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 13.711,
    y: 8.308,
    width: 4.407,
    height: 13.195,
    rx: 2.204
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 15.914,
    cy: 25.657,
    rx: 2.204,
    ry: 2.199
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPending);
export default __webpack_public_path__ + "static/media/account-pending.51ec086d.svg";
export { ForwardRef as ReactComponent };